export default class AbstractRenderer {
    done(response) {
        throw new TypeError(this.constructor.name + ' must implement the `done` method');
    }
    fail(response) {
        throw new TypeError(this.constructor.name + ' must implement the `done` method');
    }
}
